import React, { useEffect, useState } from 'react'
import { api } from "../../app/Api/ApiSlice"
import { toast } from 'react-toastify'
import { useNavigate, useParams } from 'react-router-dom'
import { FaEdit } from 'react-icons/fa'
import moment from 'moment'
import Loader from '../../components/Loader'
import "./storesStyles.css" // use the same stylesheet

// component shows all carts user has in all stores
const Carts = () => {
  const [carts, setCarts] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const navigate = useNavigate()
  const { name } = useParams()

  useEffect(() => {
    const getCarts = async () => {
      try {
        setIsLoading(true)
        const response = await api.get(`/stores/carts`)
        // console.log(response)
        if (response.data.length > 0) {
          setCarts(response.data)
        } else {
          toast.info("No saved carts found")
        }
      } catch (error) {
        toast.error(error.response?.data?.message || "Error fetching carts")
      } finally {
        setIsLoading(false)
      }
    }
    getCarts()
  }, [name])

  return (
    <div className="store-carts-container">
      <h2 className="page-title">All Carts</h2>

      <div className="table-wrapper">
        <table className="carts-table">
          <thead>
            <tr>
              <th>Date</th>
              <th>Business</th>
              <th>Cart Name</th>
              <th>No. of Items</th>
              <th>Total</th>
              <th>Comment</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {carts.length > 0 ? (
              carts.map((cart) => (
                <tr key={cart._id} onClick={()=>navigate(`/b/${cart.store.name}/carts/${cart._id}`)}>
                  <td>{moment(cart.createdAt).format("DD/MM/YYYY")}</td>
                  <td>{cart.store?.name}</td>
                  <td>{cart?.name}</td>
                  <td>{cart?.numberOfItems}</td>
                  <td className="cart-total">{cart.total}</td>
                  <td>{cart?.comment || "—"}</td>
                  <td>
                    <button
                      className="view-btn"
                      onClick={() => navigate(`/${name}/carts/${cart._id}`)}
                    >
                      <FaEdit />
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              !isLoading && (
                <tr>
                  <td colSpan="7" className="no-data">
                    No carts available
                  </td>
                </tr>
              )
            )}
          </tbody>
        </table>
        {isLoading && <Loader />}
      </div>
    </div>
  )
}

export default Carts
